import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TBToCMessage } from "../../types/types";
type TMessageList = { [id: string]: TBToCMessage };
type RoomInformation = {
  isOtherTyping: boolean;
  isOtherJoined: boolean;
  messageList: TMessageList;
};
type TInitRoom = {
  toDomain: string;
  historyMessageList: Array<TBToCMessage>;
};
type TBToCTarget = {
  toDomain: string;
};
interface TNext {
  id: string;
  createdAt: string;
  url: string;
}
type TBToCState = {
  roomInformations: { [toDomain: string]: RoomInformation };
  lastBToCTarget: TBToCTarget;
  next: TNext | null;
  previous: TNext | null;
  isScrollAbove: boolean;
};

const initialState: TBToCState = {
  roomInformations: {},
  lastBToCTarget: { toDomain: ""},
  next: null,
  previous: null,
  isScrollAbove: false,
};
type TUpdateRoomTyping = { toDomain: string; isOtherTyping: boolean };
type TUpdateRoomMessages = { toDomain: string; messageText: TBToCMessage };
export const BToCStateSlice = createSlice({
  name: "bToCState",
  initialState,
  reducers: {
    updateRoomMessages: (state, action: PayloadAction<TUpdateRoomMessages>) => {
      const toDomain = action.payload.toDomain;
      const message = action.payload.messageText;
      if (!state.roomInformations[toDomain])
        state.roomInformations[toDomain] = {
          isOtherTyping: false,
          messageList: {},
        } as RoomInformation;
      state.roomInformations[toDomain].messageList[message.id] = message;
    },
    updateRoomTyping: (state, action: PayloadAction<TUpdateRoomTyping>) => {
      const toDomain = action.payload.toDomain;
      const isOtherTyping = action.payload.isOtherTyping;
      if (!state.roomInformations[toDomain]) return;
      state.roomInformations[toDomain].isOtherTyping = isOtherTyping;
    },
    clearRoomMessages: (state, action: PayloadAction<string>) => {
      state.roomInformations = {};
    },
    initRoomInfomation: (state, action: PayloadAction<TInitRoom>) => {
      const toDomain = action.payload.toDomain;
      if (!state.roomInformations[toDomain])
        state.roomInformations[toDomain] = {
          isOtherTyping: false,
          isOtherJoined: false,
          isOtherWithPubkey: true,
          messageList: {},
        } as RoomInformation;
      action.payload.historyMessageList.forEach((message) => {
        state.roomInformations[toDomain].messageList[message.id] = message;
      });
    },
    setLastBToCTarget: (state, action: PayloadAction<TBToCTarget>) => {
      state.lastBToCTarget = action.payload;
    },
    setNext: (state, action: PayloadAction<TNext>) => {
      state.next = action.payload;
    },
    setPrevious: (state, action: PayloadAction<TNext>) => {
      state.previous = action.payload;
    },
    setIsScrollAbove: (state, action: PayloadAction<boolean>) => {
      state.isScrollAbove = action.payload;
    },
  },
});
// Action creators are generated for each case reducer function
export const {
  updateRoomMessages,
  clearRoomMessages,
  initRoomInfomation,
  updateRoomTyping,
  setLastBToCTarget,
  setNext,
  setPrevious,
  setIsScrollAbove,
} = BToCStateSlice.actions;
export default BToCStateSlice.reducer;
